import { Injectable } from '@angular/core';
import { User } from '../../models/login/user';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { DebugElement } from '@angular/core/src/debug/debug_node';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/Observable/throw';
import 'rxjs/add/operator/toPromise';
import { global } from '../../models/global';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  ROOT_URL: string = "";
    constructor(private http: Http) {
        let g: global = new global();
        this.ROOT_URL = g.getApiUrl();
    }

    authenticateUser(user: any): Observable<any> {
        let _body = JSON.stringify(user.value);
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8' });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/Account/AuthenticateUserCMaster",
            headers: headers,
            body: _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }

    checkSession(): Promise<any> {
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
          method: 'GET',
          url: this.ROOT_URL + '/api/Dashboard/UserCookieExists',
          headers: headers
      });

      return this.http.request(new Request(requestoptions))
          .map(response => <any>(<Response>response).json())
          .toPromise();

  }

  profileDetails(userid: string): Observable<any> {
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8' });
    let requestoptions: RequestOptions = new RequestOptions({
        method: 'GET',
        url: this.ROOT_URL + "/api/Account/ProfileDetails?userid="+userid,
        headers: headers
    })
    
    return this.http.request(new Request(requestoptions))
        .map((res: Response) => {
            return res.json();
        });

}

notification(): Observable<any> {
    let userId =localStorage.getItem('mcmt_userId');
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8' });
    let requestoptions: RequestOptions = new RequestOptions({
        method: 'GET',
        url: this.ROOT_URL + "/api/Account/Notification?userid="+userId,
        headers: headers
    })
    
    return this.http.request(new Request(requestoptions))
        .map((res: Response) => {
            return res.json();
        });

}

validateUser(userID: string): Observable<any> {
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8' });
    
    let requestoptions: RequestOptions = new RequestOptions({
        method: 'GET',
        url: this.ROOT_URL + '/api/Account/ISValidUsers?UserID='+userID,
        headers: headers
    })

    return this.http.request(new Request(requestoptions))
        .map((res: Response) => {
            return res;
        });

}

}

